import React from 'react';
import styles from './ContentContainer.module.css';

const ContentContainer = ({ children }) => {
    return (
        <div className={styles.page_section}>
            <div className={styles.page_content}>
                {children}
            </div>
        </div>
    );
}

export default ContentContainer;